import queryString from 'query-string'

export default (search, obj) => {
    let params = queryString.parse(search)
    return queryString.stringify({
        ...params,
        ...obj,
    })
}